<template>
    <div class="arterra-quotes">
        <blockquote class="blockquote text-center quote" v-bind:class='{quotehide: this.doHide}'>
            <p class="mb-0">{{ quote.text }}</p>
            <footer v-if="quote.author" class="blockquote-footer">{{ quote.author }}</footer>
        </blockquote>
    </div>
</template>

<script>
    export default {
        data: function(){
            return {
                index: 0,
                doHide: false,
                quote: this.quotes[0]
            };
        },
        methods: {
            next() {
                this.doHide = true;

                setTimeout(function(){
                    this.index++;
                    if(this.index>=this.quotes.length)
                        this.index = 0;
                    this.quote = this.quotes[this.index];

                    this.doHide = false;
                }.bind(this), 500);
            }
        },
        mounted() {
            setInterval((function(){
                this.next()
            }).bind(this), 6000)
        },
        props: {
            quotes: { type: Array,  required: true },
        }
    };
</script>

<style lang="scss" scoped>
    blockquote {
        transition: all 0.5s;
        &.quotehide {
            opacity: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Quotes.vue